import React, { useEffect, useState } from 'react'
import GoldSiverHeader from '../HomePage/GoldSiverHeader'
import { useDispatch, useSelector } from 'react-redux'
// import { acceptFriendRequest, declineFriendRequest, getBlockList, getFriendRequest, unblockFriend } from '../../store/friends'
import { Card, Pagination, Table } from 'react-bootstrap'
import OnlineTrainers from '../Component/OnlineTrainers'
import { getRankList } from '../../store/pages'
import { useTranslation } from 'react-i18next'

function Classification() {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const rank_list = useSelector(state => state.pages.rank_list)
    const [currentPage, setCurrentPage] = useState(1)

    const handlePageChange = (page) => {
        setCurrentPage(page)
        const payload = {
            subpage: page
        }
        dispatch(getRankList(payload))
    }

    useEffect(() => {
        const payload = {
            subpage: currentPage
        }
        dispatch(getRankList(payload))
    }, [dispatch, currentPage])

    return (
        <div>
            <GoldSiverHeader previous={'/home'} title={t('Ranking')}>
                <div className='container p-2 challenge'>
                    <Card border='dark' text='white' className='bg-theme mt-2'>
                        <Card.Header><h3 className='text-center'>{t('Ranking')}</h3></Card.Header>

                        <Card.Body className='overflow-auto'>
                            <div className='p-4' style={{ minWidth: '300px' }}>
                                <Table striped bordered hover className='table-theme'>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>{t('Trainer')}</th>
                                            <th>{t('Rank')}</th>
                                            <th>{t('Scoring')}</th>
                                            <th>{t('Status')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rank_list?.ranklist?.map((item, index) => {
                                            return (
                                                <tr key={index} style={{ verticalAlign: 'middle' }}>
                                                    <td className='text-center p-2'>
                                                        {item.medal && (
                                                            <div className="medal-position">
                                                                {item.medal === '1º' && <img src="/images/icons/medal1.png" alt="1st" />}
                                                                {item.medal === '2º' && <img src="/images/icons/medal2.png" alt="2nd" />}
                                                                {item.medal === '3º' && <img src="/images/icons/medal3.png" alt="3rd" />}
                                                                {!['1º', '2º', '3º'].includes(item.medal) && <span>{item.medal}</span>}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className='p-3'>
                                                        <div className="d-flex align-items-center">
                                                            <img 
                                                                src={item.character_img || "/images/characters/1/Thumb.png"} 
                                                                alt={item.username} 
                                                                className="me-3"
                                                                style={{ width: '40px', height: '40px' }}
                                                            />
                                                            <div>
                                                                <h5 className="mb-0">{item.username}</h5>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className='text-center'>
                                                        {item.rank_name}
                                                    </td>
                                                    <td className='text-center'>
                                                        {item.points}
                                                    </td>
                                                    <td className='text-center'>
                                                        <span className={`status-indicator ${item.online_status}`}>
                                                            {item.online_status === 'online' ? t('Online') : t('Offline')}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        {!rank_list?.ranklist?.length && (
                                            <tr>
                                                <td colSpan={5} className='text-center'>{t('No Results.')}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>

                                {rank_list?.pagination && rank_list.pagination.total_pages > 1 && (
                                    <div className='d-flex justify-content-center mt-3'>
                                        <Pagination>
                                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                                            
                                            {[...Array(Math.min(5, rank_list.pagination.total_pages)).keys()].map(i => {
                                                const pageNum = i + Math.max(1, currentPage - 2)
                                                if (pageNum <= rank_list.pagination.total_pages) {
                                                    return (
                                                        <Pagination.Item 
                                                            key={pageNum} 
                                                            active={pageNum === currentPage}
                                                            onClick={() => handlePageChange(pageNum)}
                                                        >
                                                            {pageNum}
                                                        </Pagination.Item>
                                                    )
                                                }
                                                return null
                                            })}
                                            
                                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === rank_list.pagination.total_pages} />
                                            <Pagination.Last onClick={() => handlePageChange(rank_list.pagination.total_pages)} disabled={currentPage === rank_list.pagination.total_pages} />
                                        </Pagination>
                                    </div>
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                    <div>
                        <OnlineTrainers />
                    </div>
                </div>
            </GoldSiverHeader>
            <style jsx="true">{`
                .status-indicator {
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-size: 0.85rem;
                    font-weight: bold;
                }
                .status-indicator.online {
                    background-color: #28a745;
                    color: white;
                }
                .status-indicator.offline {
                    background-color: #6c757d;
                    color: white;
                }
                .medal-position {
                    text-align: center;
                }
                .medal-position img {
                    width: 24px;
                    height: 24px;
                }
            `}</style>
        </div>
    )
}

export default Classification
